<script lang="ts" setup>
import { computed } from "vue";
import SimpleDoughnutChart from "@/components/app/charts/SimpleDoughnutChart.vue";

const props = defineProps({
  percentage: {
    type: Number,
    default: undefined,
  },
  color: {
    type: String,
  },
  radius: {
    type: Number,
    default: 150,
  },
});

const chartStyle = computed(() => {
  return {
    width: `${props.radius}px`,
    height: `${props.radius}px`,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
  };
});
</script>

<template>
  <SimpleDoughnutChart :percentage="props.percentage" :color="props.color" :styles="chartStyle" />
</template>
